import axios from './axios'
import { ListDTO } from './dto/list.dto'
import { UserDTO, TypeDto, UserDataDTO } from './dto/user.dto'

function convertTypesToIds (types: any) {
  if (!types) return []
  const typesIds = types.map((type: any) => type.id)
  return typesIds
}

class PeopleServiceClass {
  async list (queryParams: { [key: string]: string | number } = {}) {
    const res = await axios.get<ListDTO<UserDTO>>('/api/people', {
      params: queryParams
    })
    return res.data
  }

  async detail (slug: string) {
    const res = await axios.get<UserDataDTO>(`/api/people/${slug}`)
    res.data.data.types_ids = convertTypesToIds(res.data.data.types)
    return res.data
  }

  async create (person: UserDTO) {
    let reqData = new FormData()
    Object.entries(person).forEach(([key, value]) => {
      reqData.append(key, value)
    })

    const res = await axios.post<UserDTO>('/api/people', reqData)
    return res.data
  }

  async update (person: UserDTO) {
    let reqData = new FormData()
    Object.entries(person).forEach(([key, value]) => {
      reqData.append(key, value)
    })
    reqData.append('_method', 'put')

    const res = await axios.post<UserDTO>(`/api/people/${person.slug}`, reqData)
    return res.data
  }

  delete (person: UserDTO) {
    return axios.delete<UserDTO>(`api/people/${person.slug}`)
  }

  async personTypesList () {
    const res = await axios.get<ListDTO<TypeDto>>('/api/people/personTypes')
    return res.data
  }
}

const PeopleService = new PeopleServiceClass()

export {
  PeopleService
}
